import React, { createContext, useState } from "react";
import { Theme, createMuiTheme, ThemeProvider } from "@material-ui/core/styles";
import { deepOrange } from "@material-ui/core/colors";

interface IThemeContext {
  theme: Theme;
  settheme: Function;
}

const _theme_ = createMuiTheme({
  typography: {
    fontFamily: ["Montserrat-Regular", "Kanit-Regular"].join(","),
  },
  palette: {
    primary: deepOrange,
    secondary: { main: "#595A5A", light: "#7a7b7b", dark: "#3e3e3e" },
  },
});

const initalState: IThemeContext = {
  theme: _theme_,
  settheme: () => {},
};

export const ThemeContext = createContext<IThemeContext>(initalState);
export const ThemeContextProvider = (props: any) => {
  const [theme, settheme] = useState<Theme>(_theme_);
  return (
    <ThemeContext.Provider value={{ theme, settheme }}>
      <ThemeProvider theme={theme}>{props.children}</ThemeProvider>
    </ThemeContext.Provider>
  );
};
export const ThemeContextConsumer = ThemeContext.Consumer;
